import React, { useState, cache, useEffect } from "react";
import CommonConfirmModal from "../../../components/Modal/commonConfirmModal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeCache } from "../../../redux/action/member/memberAction";
import { WEB } from "../../../constant";
import { notice } from "../../../redux/action/action";

const CachePop = ({ openModal, setModalOpen }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();
  const cachePop = useSelector((state) => state.isCachePop);

  const [buttonLoading, setButtonLoading] = useState(false);
  const clearCache = () => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        action: "refreshCache",
      });
    }

    caches
      .keys()
      .then((keyList) => {
        return Promise.all(
          keyList.map((key) => {
            return caches.delete(key);
          })
        );
      })
      .then(() => {
        dispatch(closeCache());
        dispatch(notice(i18n("clearCacheSuccess"), "success"));
        setTimeout(() => {
          window.location.reload();
        }, 700);
      });
  };
  return (
    <CommonConfirmModal
      modalProps={{
        title: i18n("clearcache"),
        okButtonText: i18n("confirm"),
        buttonLoading: buttonLoading,
        content: (
          <>
            <span>{i18n("confirm-clearCache")}</span>
          </>
        ),
        cancelButtonText: i18n("cancel"),
      }}
      onConfirm={() => {
        clearCache();
      }}
      modalOpen={cachePop}
      size="mini"
      onClose={() => {
        dispatch(closeCache());
      }}
    />
  );
};

export default CachePop;
